export const COLLISION_SPECIALIST_RIDE_TEMPLATE =
  'collision_specialist_ride';

export const COLLISION_SPECIALIST_RIDE_SOURCE =
  'collision-specialist-camden';

export const COLLISION_SPECIALIST_RIDE_INTENT = 'ride_now';

export const COLLISION_SPECIALIST_PICKUP_ADDRESS =
  'Collision Specialist, 134 West Main Street, Camden, TN 38320';

export const COLLISION_SPECIALIST_RIDE_TITLE =
  'Ride from Collision Specialist';

const normalizeParam = (value) =>
  String(value || '').trim().toLowerCase();

export const isCollisionSpecialistRideRequest = ({
  queryParams,
  regionSlug,
} = {}) => {
  const slug = normalizeParam(regionSlug);
  const src = normalizeParam(queryParams?.get?.('src'));
  const source = normalizeParam(queryParams?.get?.('source'));
  const intent = normalizeParam(queryParams?.get?.('intent'));
  const template = normalizeParam(queryParams?.get?.('rideTemplate'));

  return (
    slug === 'camden' &&
    intent === COLLISION_SPECIALIST_RIDE_INTENT &&
    (src === COLLISION_SPECIALIST_RIDE_SOURCE ||
      source === COLLISION_SPECIALIST_RIDE_SOURCE ||
      template === COLLISION_SPECIALIST_RIDE_TEMPLATE)
  );
};

export const buildCollisionSpecialistRidePreset = () => ({
  type: 'task_delivery',
  taskType: 'delivery',
  rideTemplate: COLLISION_SPECIALIST_RIDE_TEMPLATE,
  title: COLLISION_SPECIALIST_RIDE_TITLE,
  description: COLLISION_SPECIALIST_RIDE_TITLE,
  pickupAddress: COLLISION_SPECIALIST_PICKUP_ADDRESS,
});

export const getCollisionSpecialistRideSuggestedPrice = (miles) => {
  const numericMiles = Number(miles);
  if (!Number.isFinite(numericMiles) || numericMiles < 0) return null;
  return Math.max(8, Math.ceil(numericMiles * 2));
};
